import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';

const normalizeEmail = (value) => String(value || '').trim().toLowerCase();

const TagInput = forwardRef(function TagInput(
  { label, helperText, tags, setTags, placeholder },
  ref
) {
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);

  const commit = () => {
    const additions = inputValue
      .split(/[\n,;]+/)
      .map(normalizeEmail)
      .filter(Boolean);
    if (!additions.length) return;
    setTags(Array.from(new Set([...(Array.isArray(tags) ? tags : []), ...additions])));
    setInputValue('');
  };

  useImperativeHandle(ref, () => ({
    commit,
    focus: () => inputRef.current?.focus(),
  }));

  return (
    <label className="field field-wide">
      <span>{label}</span>
      <div className="tag-editor" onClick={() => inputRef.current?.focus()}>
        {(Array.isArray(tags) ? tags : []).map((tag) => (
          <span className="tag" key={tag}>
            {tag}
            <button
              type="button"
              aria-label={`Remove ${tag}`}
              onClick={(event) => {
                event.stopPropagation();
                setTags(tags.filter((item) => item !== tag));
              }}
            >
              ×
            </button>
          </span>
        ))}
        <input
          ref={inputRef}
          type="email"
          value={inputValue}
          placeholder={placeholder}
          onChange={(event) => setInputValue(event.target.value)}
          onBlur={commit}
          onKeyDown={(event) => {
            if (['Enter', ',', ';'].includes(event.key)) {
              event.preventDefault();
              commit();
            }
          }}
        />
      </div>
      {helperText ? <small>{helperText}</small> : null}
    </label>
  );
});

export default TagInput;
